import React from "react";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import _ from "lodash";

//Component
import NotesModal from "../CustomUIComponents/NotesModal/NotesModal";
import EditableModal from "../LoanDetails/EditableModal";

//Constants
import {
  BASIC_ADMIN_INFO_DETAILS_ARRAY,
  OTHER_INFO_DETAILS_ARRAY,
  REFERENCES,
  ADDRESS,
  NOTES_TYPE,
  VIEW_LOAN_APP_TYPES,
  EMI_CALCULATION,
  ainfo,
  sd,
  loanApplicationEdit,
  loanUpdateMandetoryCheck,
  LOAN_TYPES,
} from "./Constants";
import { PERSONAL_LOAN_FIELD_OVERRIDES } from "../CreateLoan/CreateLoanConstants";
import {
  EVIDENCE,
  CONFIGURATION_DATE_TIME_FORMAT,
  INVOICE_DATE_FORMAT,
} from "../../constants/appConstants";

//Strings
import { Strings } from "../../resources/i18n/i18n";

//Utils
import Utility from "../../utils/Utility";

// Styles
import "../ViewLoanApplication/ViewLoanApplication.scss";

//Assets
import addNotes from "../../resources/images/ic_add_note.svg";
import editNote from "../../resources/images/ic_edit.svg";
import deleteNote from "../../resources/images/ic_cross_blue.svg";
import loanImage from "../../resources/images/ic_loan_portfolio_details.svg";
import personalLoanImage from "../../resources/images/ic_personal_loan.svg";

class ViewLoanApplication extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notesModal: false,
      isEditNote: false,
      note: "",
      noteId: null,
      showModal: false,
      editableData: {},
      sectionToEdit: undefined,
      errorFieldArray: []
    };
  }

  renderHeader = (headerText) => {
    return (
      <span className='fullWidth subHeaderText'>{headerText}</span>
    );
  };

  isPersonalLoan = () => this.props.loanInfo?.type === LOAN_TYPES.PERSONAL_LOAN;

  // Resolve a field's display label, applying PERSONAL_LOAN label overrides when applicable.
  // Only the label changes — the data key sent to the API stays the same.
  getDetailLabel = (detail) => {
    if (this.isPersonalLoan()) {
      const override = PERSONAL_LOAN_FIELD_OVERRIDES[detail.key];
      if (override?.labelKey) {
        return Strings(override.labelKey);
      }
    }
    return detail.title;
  };

  // Fields flagged as hidden for PERSONAL_LOAN are not collected, so hide them in the details view too.
  isDetailHidden = (detail) =>
    this.isPersonalLoan() && PERSONAL_LOAN_FIELD_OVERRIDES[detail.key]?.hidden === true;

  renderApplicationDetails = (info, props, invalidValues = [], applyOverride = false) => {
    const title = applyOverride ? this.getDetailLabel(props) : props.title;
    return (
      <Col
        md={3}
        className={'infoViewContainer paddingSeparation ps-0'}
        key={props.key}
      >
        <div
          className={invalidValues.includes(props.key)
            ? 'errors m-0 p-0'
            : 'infoHeader'}>
          {title}
        </div>
        {info ? props.formatter(info[props.key]) : null}
      </Col>
    );
  };

  //Toggle update loan information modal
  showEditLoanFormModal = (section = undefined, invalidValues = []) => {
    this.setState({
      showModal: !this.state.showModal,
      errorMessage: "",
      errorFieldArray:[],
      invalidValues: invalidValues
    }, () => {
      if (this.state.showModal) {
        this.editLoanApplicationForm(section)
      }
    })
  }


  editLoanApplicationForm = (sectionToEdit) => {
    let dropdowns = [];
    this.props.dropdownValues.forEach((value) => {
      if (sectionToEdit === "basicInfo" && value.ft === "BASIC_INFO") {
        dropdowns = value.ff
      } else if (sectionToEdit === "income" && value.ft === "INCOME") {
        dropdowns = value.ff
      } else if (sectionToEdit === "expenses" && value.ft === "EXPENSES") {
        dropdowns = value.ff
      } else if (sectionToEdit === "siteVisit" && value.ft === "SITE_VISIT") {
        dropdowns = value.ff
      }
    })
    let editableData = {};
    if (sectionToEdit === "comercialRef1" ||
      sectionToEdit === "comercialRef2" ||
      sectionToEdit === "personalRef1" ||
      sectionToEdit === "personalRef2" ||
      sectionToEdit === "neighbourhoodRef1" ||
      sectionToEdit === "neighbourhoodRef2"
    ) {
      editableData["additionalInfo"] = {
        ...this.props.additionalInfo,
        [sectionToEdit]: this.props.additionalInfo[sectionToEdit]
          ? this.props.additionalInfo[sectionToEdit]
          : {}
      };
    } else if (sectionToEdit === "supplierInfo") {
      editableData["loanInfo"] = {
        ...this.props.loanInfo,
        accountInfo: this.props.loanInfo.accountInfo
          ? this.props.loanInfo.accountInfo
          : {}
      };
    } else if (sectionToEdit === "basicInfo") {
      editableData["basicInfo"] = {
        ...this.props.basicInfo,
        bankDetail: this.props.basicInfo.bankDetail
          ? this.props.basicInfo.bankDetail
          : [],
        socialMediaAccountDetails: this.props.basicInfo.socialMediaAccountDetails
          ? this.props.basicInfo.socialMediaAccountDetails
          : [],
      };
    } else {
      editableData = { [sectionToEdit]: this.props[sectionToEdit] };
    }
    this.setState({
      sectionToEdit,
      editableData,
      dropdowns
    })
  }

  //Update admin date of birth
  handleAdminDOBChange = (value) => {
    let editableData = this.state.editableData;
    editableData["basicInfo"] = {
      ...editableData["basicInfo"],
      adminDateOfBirth: Utility.convertDateIntoMiliSeconds(value)
    };
    this.setState({
      editableData
    })
  };

  //Update owner date of birth
  handleOwnerDOBChange = (value) => {
    let editableData = this.state.editableData;
    editableData["basicInfo"] = {
      ...editableData["basicInfo"],
      ownerDateOfBirth: Utility.convertDateIntoMiliSeconds(value)
    };
    this.setState({
      editableData
    })
  };

  //handle input fields change
  handleInputChange = (event) => {
    let name = event.target.name;
    let value = event.target.value === Strings("select") ? "" : event.target.value;
    let editableData = {}
    if (this.state.sectionToEdit === "comercialRef1" ||
      this.state.sectionToEdit === "comercialRef2" ||
      this.state.sectionToEdit === "personalRef1" ||
      this.state.sectionToEdit === "personalRef2" ||
      this.state.sectionToEdit === "neighbourhoodRef1" ||
      this.state.sectionToEdit === "neighbourhoodRef2") {
      editableData = { additionalInfo: { ...this.state.editableData.additionalInfo, [this.state.sectionToEdit]: this.state.editableData.additionalInfo[this.state.sectionToEdit] } };
      editableData.additionalInfo[this.state.sectionToEdit] = {
        ...editableData.additionalInfo[this.state.sectionToEdit],
        [name]: value
      }
    } else if (this.state.sectionToEdit === "supplierInfo") {
      if (name === "selectedDisbursementType" || name === "selectedTransferAccountType") {
        if (value === "DELIVERY" || value === "SUPPLIER_ACCOUNT") {
          editableData = { loanInfo: { ...this.state.editableData.loanInfo } };
          editableData.loanInfo = {
            ...editableData.loanInfo,
            [name]: value,
            accountInfo: null,
            selectedTransferAccountType: value === "DELIVERY"
              ? null
              : value,
          }
        } else {
          editableData = { loanInfo: { ...this.state.editableData.loanInfo } };
          editableData.loanInfo = {
            ...editableData.loanInfo,
            accountInfo: this.props.loanInfo.accountInfo
              ? this.props.loanInfo.accountInfo
              : {},
            [name]: value,
          }
        }
      } else if (name === "supplierId") {
        editableData = { loanInfo: { ...this.state.editableData.loanInfo } };
        editableData.loanInfo = {
          ...editableData.loanInfo,
          [name]: value
        }
      } else if (name === "bankName" || name === "accountNumber") {
        editableData = { loanInfo: { ...this.state.editableData.loanInfo } };
        editableData.loanInfo["accountInfo"] = {
          ...editableData.loanInfo["accountInfo"],
          [name]: value,
          accountType: name === "bankName"
            ? []
            : editableData.loanInfo["accountInfo"]["accountType"]
        }
      } else if (name === "accountType") {
        editableData = { loanInfo: { ...this.state.editableData.loanInfo } };
        editableData.loanInfo["accountInfo"] = {
          ...editableData.loanInfo["accountInfo"],
          [name]: value,
        }
      }
    } else {
      editableData = {
        [this.state.sectionToEdit]: this.state.editableData !== undefined
          ? this.state.editableData[this.state.sectionToEdit]
          : this.props[this.state.sectionToEdit]
      };
      if (name === "holder") {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value,
          adminDateOfBirth: null,
          adminName: null,
          adminId: "",
          adminNumber: "",
          adminSince: "",
          adminAddress: null,
          adminSalary: ""
        }
      } else if (name === "socialMediaAccountDetails") {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value,
          socialMediaAccount: value.length !== 0 ? true : false
        }
      } else if (name === "remittanceDetails") {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value,
          receivesRemittances: value ? true : false
        }
      } else if (name === "bankDetail") {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value,
          bankAccount: value.length !== 0 ? true : false
        }
      } else if (this.state.sectionToEdit === "income") {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value,
          monthlyIncome: null
        }
      }
      else {
        editableData[this.state.sectionToEdit] = {
          ...editableData[this.state.sectionToEdit],
          [name]: value
        }
      }
    }
    let updatedErrorFieldArray = [];
    if (name) {
      updatedErrorFieldArray = this.state.errorFieldArray;
      updatedErrorFieldArray = updatedErrorFieldArray.filter(item => item !== name);
    }
    this.setState({
      editableData,
      errorMessage: "",
      errorFieldArray: updatedErrorFieldArray
    }
    )
  }

  updateLoanApplicationForm = () => {
    let newSection, oldSection;
    const errorFieldArray = [];
    if (this.state.sectionToEdit === "supplierInfo") {
      //Supplier Info is stored in loanInfo of editableData.
      newSection = this.state.editableData.loanInfo;
      oldSection = this.props.loanInfo;
    } else {
      //References are stored in additionalInfo of editableData.
      newSection = this.state.editableData[this.state.sectionToEdit]
        ? this.state.editableData[this.state.sectionToEdit]
        : this.state.editableData.additionalInfo[this.state.sectionToEdit];
      oldSection = this.props[this.state.sectionToEdit]
        ? this.props[this.state.sectionToEdit]
        : this.props.additionalInfo[this.state.sectionToEdit];
    }
    //Validations to update loan application form
    let errorMessage = "";
    let dropDownList = {};
    this.state.dropdowns.forEach((dropdownValue) => {
      dropDownList[dropdownValue.nm] = dropdownValue.opt;
    })
    if (_.isEqual(newSection, oldSection)) {
      errorMessage = Strings("sameInput");
    }
    //Mandetory Input Fields cannot be empty and character length validations.
    // For PERSONAL_LOAN, fields hidden in the basic-info form are not collected, so they are not
    // required here. "holder" is kept (its value persists as OWNER and gates DOB age validation).
    let mandatoryFields = loanUpdateMandetoryCheck[this.state.sectionToEdit];
    if (this.isPersonalLoan() && this.state.sectionToEdit === "basicInfo") {
      mandatoryFields = mandatoryFields.filter(
        (field) => field === "holder" || !PERSONAL_LOAN_FIELD_OVERRIDES[field]?.hidden
      );
    }
    mandatoryFields.forEach((field) => {
      let index;
      if (field !== "bankDetail" && field !== "socialMediaAccountDetails") {
        index = Object.keys(dropDownList).includes(field) && dropDownList[field].findIndex(element => {
          return element.toLowerCase() === newSection[field]?.toLowerCase();
        });
      } else if (field === "bankDetail") {
        if ((newSection["bankAccount"] && newSection["bankDetail"].length === 0)) {
          errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings(field)}`;
          errorFieldArray.push(field);
        }
      } else if (field === "socialMediaAccount") {
        if ((newSection["socialMediaAccount"] && newSection["socialMediaAccountDetails"].length === 0)) {
          errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings(field)}`;
          errorFieldArray.push(field);
        }
      }
      if (index === -1) {
        errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings(field)}`;
        errorFieldArray.push(field);
      } else if (this.state.sectionToEdit === "supplierInfo") {
        // Supplier business name is required for every disbursement type except PERSONAL_LOAN, which has no supplier.
        if (newSection["selectedDisbursementType"] === "TRANSFER"
          && newSection["selectedTransferAccountType"] === "PERSONAL_ACCOUNT") {
          if (!this.isPersonalLoan() && !newSection["supplierId"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("businessName")}`;
            errorFieldArray.push("supplierId");
          }
          if(!newSection.accountInfo["bankName"]){
            errorMessage=`${Strings("pleaseSelectRequiredFields")} - ${Strings("bankName")}`;
            errorFieldArray.push("bankName")
          }
          if(!newSection.accountInfo["accountType"] || newSection.accountInfo["accountType"]?.length<1){
            errorMessage=`${Strings("pleaseSelectRequiredFields")} - ${Strings("accountType")}`;
            errorFieldArray.push("accountType")
          }
          if(!newSection.accountInfo["accountNumber"]){
            errorMessage=`${Strings("pleaseSelectRequiredFields")} - ${Strings("accountNumber")}`;
            errorFieldArray.push("accountNumber")
          }else if (field === "accountNumber"
            && newSection.accountInfo["accountNumber"].length < 6) {
            errorMessage = Strings("accountNumberNotValid");
            errorFieldArray.push("accountNumber");
          }
        } else if (newSection["selectedDisbursementType"] === "DELIVERY") {
            if (!this.isPersonalLoan() && !newSection["supplierId"]) {
              errorMessage = `${Strings("pleaseSelectRequiredFields")} - 1${Strings("businessName")}`;
              errorFieldArray.push("supplierId");
            }
          }else if(newSection["selectedDisbursementType"] === "TRANSFER"){
              if(!newSection["selectedTransferAccountType"]){
                errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("stat")}`;
                errorFieldArray.push("selectedTransferAccountType");
              }
              if(!this.isPersonalLoan() && !newSection["supplierId"]){
                errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("businessName")}`;
              errorFieldArray.push("supplierId");
              }
          } else {
            if (!newSection["selectedDisbursementType"]) {
              errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("sdt")}`;
              errorFieldArray.push("selectedDisbursementType");
            }
            if(!this.isPersonalLoan() && !newSection["supplierId"]){
              errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("businessName")}`;
              errorFieldArray.push("supplierId");
            }
          }
      } else if (!newSection[field]) {
        errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings(field)}`;
        errorFieldArray.push(field);
      } else if (field === "holder") {
        if (newSection["holder"] !== "OWNER") {
          if (!newSection["adminDateOfBirth"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminDateOfBirth")}`;
            errorFieldArray.push("adminDateOfBirth");
          } else if (!newSection["adminName"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminName")}`;
            errorFieldArray.push("adminName");
          } else if (!newSection["adminId"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminId")}`;
            errorFieldArray.push("adminId");
          } else if (!newSection["adminNumber"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminNumber")}`;
            errorFieldArray.push("adminNumber");
          } else if (!newSection["adminSince"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminSince")}`;
            errorFieldArray.push("adminSince");
          } else if (!newSection["adminAddress"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminAddress")}`;
            errorFieldArray.push("adminAddress");
          } else if (!newSection["adminSalary"]) {
            errorMessage = `${Strings("pleaseSelectRequiredFields")} - ${Strings("adminSalary")}`;
            errorFieldArray.push("adminSalary");
          }
        }
        if (newSection["adminDateOfBirth"] && moment().diff(moment(newSection["adminDateOfBirth"]), 'year') < 21) {
          errorMessage = `${Strings("ageMustBeInBetweenTwentyOneToSixtyFive")} - ${Strings("adminDateOfBirth")}`
          errorFieldArray.push("adminDateOfBirth");
        } else if (newSection["adminNumber"] && newSection["adminNumber"].length !== 10) {
          errorMessage = `${Strings("MobileNumberMustBeTenDigits")} - ${Strings("adminNumber")}`
          errorFieldArray.push("adminNumber");
        }
        else if (newSection["adminId"] && newSection["adminId"].length !== 11) {
          errorMessage = `${Strings("CedulaIdMustBeElevenDigits")} - ${Strings("adminId")}`
          errorFieldArray.push("adminId");
        }
        else {
          if (newSection["ownerDateOfBirth"] && moment().diff(moment(newSection["ownerDateOfBirth"]), 'year') < 21) {
            errorMessage = `${Strings("ageMustBeInBetweenTwentyOneToSixtyFive")} - ${Strings("ownerDateOfBirth")}`;
            errorFieldArray.push("ownerDateOfBirth");
          }
        }
      } else if (this.state.sectionToEdit !== "expenses"
        && ((field === "telephone" && newSection["telephone"].length !== 10)
          || (field === "ownerNumber" && newSection["ownerNumber"].length !== 10)
          || (field === "phone" && newSection["phone"].length !== 10))
      ) {
        errorMessage = `${Strings("MobileNumberMustBeTenDigits")} - ${Strings(field)}`
        errorFieldArray.push(field);
      }
    })

    if (errorMessage) {
      this.setState({ errorMessage,errorFieldArray})
    } else {
      if (this.state.sectionToEdit === "basicInfo") {
        let editableData = this.state.editableData;
        loanApplicationEdit.basicInfo.forEach((obj) => {
          editableData["basicInfo"][obj.name] = editableData.basicInfo[obj.name] === ""
            ? null
            : editableData.basicInfo[obj.name]
        })
        this.props.updateLoanApplicationForm(editableData, this.showEditLoanFormModal)
      } else if (this.state.sectionToEdit === "income") {
        let editableData = this.state.editableData;
        editableData["expenses"] = this.props.expenses;
        this.props.updateLoanApplicationForm(editableData, this.showEditLoanFormModal)
      } else {
        this.props.updateLoanApplicationForm(this.state.editableData, this.showEditLoanFormModal)
      }
    }
  }

  // Editable modal to update loan application form fields
  renderEditableModal = () => {
    let editableData = {
      [this.state.sectionToEdit]: loanApplicationEdit[this.state.sectionToEdit].map((obj1) => {
        let dropDownList = [];
        let isSelection = false;
        let isVisible = this.state.sectionToEdit !== "supplierInfo";
        let isMandatoryField = obj1.isMandatoryField;

        // PERSONAL_LOAN label/visibility overrides for the basic-info and income edit sections.
        const personalLoanOverride =
          this.isPersonalLoan() &&
          (this.state.sectionToEdit === "basicInfo" || this.state.sectionToEdit === "income")
            ? PERSONAL_LOAN_FIELD_OVERRIDES[obj1.name]
            : undefined;

        //If application holder is admin then only admin details are mandetory
        if (obj1.name === "adminDateOfBirth" || obj1.name === "adminName"
          || obj1.name === "adminId" || obj1.name === "adminNumber"
          || obj1.name === "adminSince" || obj1.name === "adminAddress"
          || obj1.name === "adminSalary") {
          if (this.state.editableData[this.state.sectionToEdit]["holder"] === "OWNER") {
            isVisible = true;
          } else {
            isMandatoryField = true;
          }
        }
        //Drowdown list from backend
        if (obj1.type === "select") {
          if (this.state.sectionToEdit !== "supplierInfo") {
            this.state.dropdowns.forEach((dropdownValue) => {
              if (dropdownValue.nm === obj1.name) {
                dropDownList = [];
                dropDownList = dropdownValue.opt.map((dropdown) => {
                  return (obj1.name === "homeLocation" || obj1.name === "businessType") ? dropdown : dropdown.toUpperCase();
                });
                isSelection = true;
              }
            })
          } else {
            this.props.supplierDropdownValues.forEach((supplierDropdownValue) => {
              if (obj1.name === "selectedDisbursementType") {
                dropDownList.push(supplierDropdownValue.disbursementType);
                isSelection = true;

              } else if (obj1.name === "selectedTransferAccountType") {
                // PERSONAL_LOAN has no supplier, so SUPPLIER_ACCOUNT is not a valid transfer target.
                dropDownList = this.isPersonalLoan()
                  ? supplierDropdownValue.accountTypes?.filter((opt) => (opt?.value || opt) !== "SUPPLIER_ACCOUNT")
                  : supplierDropdownValue.accountTypes;
                isSelection = true;

              } else {
                dropDownList = []
              }
            })
            this.props.suppliersList.forEach((supplier) => {
              if (obj1.name === "supplierId") {
                dropDownList.push({ name: supplier["businessName"], value: supplier["supplierId"] });
                isSelection = true;
              }
            })
            if (this.state.editableData.loanInfo["selectedDisbursementType"] === "TRANSFER"
              && this.state.editableData.loanInfo["selectedTransferAccountType"] === "PERSONAL_ACCOUNT") {
              this.props.bankDetails.forEach((bank) => {
                if (obj1.name === "bankName") {
                  dropDownList.push(bank["bn"]);
                  isSelection = true;
                  isVisible = true;
                  isMandatoryField = true;
                } else if (this.state.editableData?.loanInfo?.accountInfo?.bankName
                  && obj1.name === "accountType") {
                  if (bank.bn === this.state.editableData.loanInfo.accountInfo.bankName) {
                    bank.ad.forEach((acc) => {
                      dropDownList.push(acc.at);
                      isSelection = true;
                      isVisible = true;
                      isMandatoryField = true;

                    })
                  }
                }

              })
            }
          }
        } else if (obj1.isSelect === "multiSelect") {
          this.state.dropdowns.forEach((dropdownValue) => {
            if (dropdownValue.nm === obj1.name) {
              dropDownList = dropdownValue.opt;
              isMandatoryField = false;
            }
          })
        } else {
          dropDownList = []
        }
        if (dropDownList.length !== 0
          && dropDownList[0] !== Strings("select")
          && obj1.name !== "socialMediaAccountDetails"
          && obj1.name !== "bankDetail") {
          dropDownList.unshift(Strings("select"))
        }
        let value;
        if (this.state.sectionToEdit === "comercialRef1" ||
          this.state.sectionToEdit === "comercialRef2" ||
          this.state.sectionToEdit === "personalRef1" ||
          this.state.sectionToEdit === "personalRef2" ||
          this.state.sectionToEdit === "neighbourhoodRef1" ||
          this.state.sectionToEdit === "neighbourhoodRef2") {
          value = !_.isEmpty(this.state.editableData)
            ? this.state.editableData.additionalInfo[this.state.sectionToEdit][obj1.name]
            : this.props.additionalInfo[this.state.sectionToEdit][obj1.name]
        }
        else if (this.state.sectionToEdit === "supplierInfo") {
          if (obj1.name === "selectedDisbursementType") {
            value = !_.isEmpty(this.state.editableData)
              ? this.state.editableData.loanInfo[obj1.name]
              : this.props.loanInfo.supplierDetails[obj1.name]
            isVisible = true;
            isMandatoryField = true;

          } if (obj1.name === "supplierId") {
            value = !_.isEmpty(this.state.editableData)
              ? this.state.editableData.loanInfo["supplierId"]
              : this.props.loanInfo["supplierId"]
            // PERSONAL_LOAN has no supplier, so the business-name field is hidden and not mandatory.
            isVisible = !this.isPersonalLoan();
            isMandatoryField = !this.isPersonalLoan();
          }
          if (this.state.editableData.loanInfo["selectedDisbursementType"] === "TRANSFER") {
            if (this.state.editableData.loanInfo["selectedTransferAccountType"] === "PERSONAL_ACCOUNT"
              && (obj1.name === "bankName" || obj1.name === "accountType" || obj1.name === "accountNumber")) {
              value = !_.isEmpty(this.state.editableData)
                && this.state.editableData.loanInfo.accountInfo
                ? this.state.editableData.loanInfo.accountInfo[obj1.name]
                : this.props.loanInfo.accountInfo[obj1.name]
              isVisible = true;
              isMandatoryField = true;
            }
            if (obj1.name === "selectedTransferAccountType") {
              value = !_.isEmpty(this.state.editableData)
                ? this.state.editableData.loanInfo[obj1.name]
                : this.props.loanInfo[obj1.name]
              isVisible = true;
              isMandatoryField = true;
            }
          }
        }
        else {
          value = !_.isEmpty(this.state.editableData)
            ? this.state.editableData[this.state.sectionToEdit][obj1.name]
            : this.props[this.state.sectionToEdit][obj1.name]
        }
        if (obj1.isDate) {
          value = value ? moment(value).format(INVOICE_DATE_FORMAT) : "";
          if (obj1.name === "ownerDateOfBirth") {
            obj1["handleDateChange"] = this.handleOwnerDOBChange
          } else if (obj1.name === "adminDateOfBirth") {
            obj1["handleDateChange"] = this.handleAdminDOBChange
          }
        }

        let finalValue = value;
        if (!_.isEmpty(this.state.editableData)) {
          if (obj1.isSelect === "multiSelect") {
            finalValue.forEach((ele) => {
              if (!dropDownList.includes(ele)) {
                finalValue.splice(ele, 1)
              }
            })
          }
        } else {
          finalValue = this.props[this.state.sectionToEdit][obj1.name]
        }
        return {
          ...obj1,
          title: personalLoanOverride?.labelKey || obj1.title,
          value: finalValue,
          dropDownList: dropDownList,
          isSelection: isSelection,
          isVisible: personalLoanOverride?.hidden ? false : isVisible,
          isMandatoryField: personalLoanOverride?.hidden ? false : isMandatoryField,
          md: 4,
          className: this.state.invalidValues.includes(obj1.name) ? 'errors m-0 p-0' : ''
        }
      }
      )
    }
    //If isVisible is false, then the fields will not be visible on UI
    let filteredEditableData = editableData[this.state.sectionToEdit].filter(
      (obj) => obj.isVisible === true
    );
    return (
      <EditableModal
        open={this.state.showModal}
        modalCloseOnEsc={false}
        modalCloseOnOverlayClick={false}
        modalShowCloseIcon={false}
        headerText={Strings("EditLoanDetails")}
        modalButtonCancel={{
          text: Strings("Cancel"),
          onClick: this.showEditLoanFormModal,
        }}
        modalButtonOk={{
          text: Strings("Submit"),
          onClick: this.updateLoanApplicationForm,
        }}
        SubmitMinimartDetails={this.updateLoanApplicationForm}
        onChange={this.handleInputChange}
        errorMessage={this.state.errorMessage}
        editableData={filteredEditableData}
        className={"loanApplicationModal"}
        invalidValues={this.state.invalidValues}
        errorFieldArray={this.state.errorFieldArray}
        isNotTranfser={(this.props.supplierInfo && this.state.editableData && this.state.editableData?.loanInfo?.selectedDisbursementType !== "TRANSFER")}
      />
    );
  };
  renderBasicAndadminInformation = (details) => {
    let invalidFormFieldValues = {};
    let invalidFormFieldKeys = [];
    let invalidValues = [];

    if (this.props?.invalidFormField?.length > 0) {
      invalidFormFieldKeys = this.props?.invalidFormField?.map((field) => {
        return field.ft;
      });
      this.props?.invalidFormField?.forEach((field) => {
        if (field.ft === "BASIC_INFO") {
          invalidFormFieldValues = { ...invalidFormFieldValues, [field.ft]: field.ff };
        }
      });
      invalidFormFieldKeys.forEach((invalidFormFieldKey) => {
        if (invalidFormFieldKey === "BASIC_INFO") {
          invalidValues = [...invalidValues, ...invalidFormFieldValues[invalidFormFieldKey]];
        }
      });
    }
    // For PERSONAL_LOAN the "Administration Information" section is shown as "Employment Information".
    const displayHeader =
      this.isPersonalLoan() && details.header === Strings("AdministrationInformation")
        ? Strings("EmploymentInfo")
        : details.header;
    const visibleFields = details.keysArray.filter((detail) => !this.isDetailHidden(detail));
    return (
      <div key={details.header}>
        {this.renderHeader(displayHeader)}
        {this.props.isAnalyst && details.header !== Strings("AdministrationInformation")
          && details.header !== Strings("SiteVisit")
          && <span className='pencil w-auto mx-1 px-1'>
            <img //NOSONAR
              src={editNote}
              className={"editIcon m-0"}
              alt={"edit"}
              title={Strings("EditLoanDetails")}
              onClick={() => this.showEditLoanFormModal(details.propObjectKey, invalidValues)}
            />
          </span>}
        <div className='errors p-0 m-0'>
          {invalidFormFieldValues["BASIC_INFO"]
            && details.propObjectKey === "basicInfo"
            && details.header !== Strings("AdministrationInformation")
            && <div>{Strings("errorInvalidValue")}</div>}
        </div>
        <Row>
          {visibleFields.map((detail) =>
            this.renderApplicationDetails(
              this.props[details.propObjectKey],
              detail,
              invalidValues,
              true
            )
          )}
        </Row>
        <hr className='fullWidth opacity-100' />
      </div>
    );
  };
  renderOtherInformation = (details) => {
    let invalidFormFieldValues = {};
    let invalidFormFieldKeys = [];
    let invalidValues = [];
    if (this.props?.invalidFormField?.length > 0) {
      invalidFormFieldKeys = this.props?.invalidFormField?.map((field) => {
        return field.ft;
      });
      this.props?.invalidFormField?.forEach((field) => {
        if (invalidFormFieldKeys.includes(field.ft)) {
          invalidFormFieldValues = { ...invalidFormFieldValues, [field.ft]: field.ff };
        }
      });
      invalidFormFieldKeys.forEach((invalidFormFieldKey) => {
        if (invalidFormFieldKey !== "BASIC_INFO") {
          invalidValues = [...invalidValues, ...invalidFormFieldValues[invalidFormFieldKey]];
        }
      });
    }
    // PERSONAL_LOAN relabels only the income (financial) fields here; expenses/site-visit keep
    // their labels (the "telephone" key is reused as a bill expense, so overriding must be scoped).
    const applyOverride = this.isPersonalLoan() && details.propObjectKey === "income";
    return (
      <div key={details.header}>
        {this.renderHeader(details.header)}
        {this.props.isAnalyst && details.header !== Strings("SiteVisit")
          && <span className='pencil mx-1 px-1'>
            <img //NOSONAR
              src={editNote}
              className={"editIcon m-0"}
              alt={"edit"}
              title={Strings("EditLoanDetails")}
              onClick={() => this.showEditLoanFormModal(details.propObjectKey, invalidValues)}
            />
          </span>}
        <div className='errors p-0 m-0'>
          {invalidFormFieldValues["INCOME"]
            && details.propObjectKey === "income"
            && <div>{Strings("errorInvalidValue")}</div>}
          {invalidFormFieldValues["EXPENSES"]
            && details.propObjectKey === "expenses"
            && <div>{Strings("errorInvalidValue")}</div>
          }
          {invalidFormFieldValues["SITE_VISIT"]
            && details.propObjectKey === "siteVisit"
            && <div>{Strings("errorInvalidValue")}</div>}
        </div>
        <Row>
          {" "}
          {details.keysArray.map((detail) =>
            this.renderApplicationDetails(
              this.props[details.propObjectKey],
              detail,
              invalidValues,
              applyOverride
            )
          )}
        </Row>
        <hr className='fullWidth opacity-100' />
      </div >
    );
  };

  // PERSONAL_LOAN relabels evidence groups: LOCAL_PHOTO -> Location Photo, INVOICE -> Document Photo.
  getEvidenceTitle = (evidenceDoc) => {
    if (this.isPersonalLoan()) {
      const number = evidenceDoc.type.match(/\d+$/)?.[0] || "";
      if (evidenceDoc.type.startsWith("LOCAL_PHOTO")) {
        return Strings("LOCATION_PHOTO").concat(" ", number).trim();
      }
      if (evidenceDoc.type.startsWith("INVOICE")) {
        return Strings("DOCUMENT_PHOTO").concat(" ", number).trim();
      }
    }
    return evidenceDoc.title;
  };

  renderEvidenceDocuments = () => {
    return (
      <>
        <Row className='fullWidth '>
          <Col md={10} className='p-0 subHeaderText'>
            {Strings("Evidence")}
          </Col>
          {this.props.isAnalyst && (
            <Col md={2} className='px-0'>
              <div className='pull-right'>
                <img
                  src={addNotes}
                  alt={"addNotes"}
                  className={"addNotesIcon cursorPointer"}
                  onClick={() =>
                    this.toggleModal(null, NOTES_TYPE.EVALUATION_NOTE)
                  }
                />
                <span className='noteText'>{Strings("Notes")}</span>
              </div>
            </Col>
          )}
        </Row>
        {this.props.documents && this.props.documents.length > 0 && (
          <Row>
            {EVIDENCE.map((evidenceDoc) => {
              let documentId = null;
              const doc = this.props.documents.find(
                (document) => document.docType === evidenceDoc.type
              );
              if (doc) {
                documentId = doc.documentId;
              }
              const evidenceTitle = this.getEvidenceTitle(evidenceDoc);
              return (
                <Col
                  md={3}
                  className='infoViewContainer paddingSeparation ps-0'
                  key={evidenceDoc.type}
                >
                  <div className='infoHeader'>
                    {evidenceTitle}
                  </div>
                  <div className='infoContent'>
                    {documentId ? (
                      <div>
                        <span
                          className='infoContent cursorPointer url'
                          onClick={() =>
                            this.props.viewDocument(documentId)
                          }
                        >
                          {evidenceTitle + " " + documentId}
                        </span>
                        {this.props.initiatedFrom !== "TPRESTA" && this.props.isAnalyst && (
                          <i
                            className='ps-2 fa fa-trash cursorPointer'
                            aria-hidden='true'
                            title='Eliminar Subtipo'
                            onClick={() => {
                              this.props.handleDeleteEvidenceClick(
                                documentId
                              );
                            }}
                          />
                        )}
                      </div>
                    ) : (
                      Strings("NA")
                    )}
                  </div>
                </Col>
              );
            })}
          </Row>
        )}
      </>
    );
  };

  renderNotes = (noteData) => {
    return (
      <div className='noteSection' key={noteData.id}>
         <span className='pe-3 authorText'>
          {Strings("author")}:&nbsp;
          {noteData.author}
        </span>
        <span className='subText'>
          {moment(noteData.ca).format(CONFIGURATION_DATE_TIME_FORMAT)}
        </span>
        <div className='spaceForIcons'>
          {this.props.isAnalyst && !this.props.isHistory && (
            <img
              src={deleteNote}
              className='NotesIcon cursorPointer  pull-right'
              alt={"delete"}
              onClick={() => {
                this.props.deleteNote(
                  noteData.id,
                  NOTES_TYPE.EVALUATION_NOTE
                );
              }}
            />
          )}
          {this.props.isAnalyst && !this.props.isHistory && (
            <img
              src={editNote}
              className={
                this.props.isAnalyst
                  ? "NotesIcon cursorPointer  pull-right"
                  : "NotesIcon pull-right"
              }
              alt={"edit"}
              onClick={() => {
                this.setState({ isEditNote: true }, () => {
                  this.toggleModal(
                    noteData.note,
                    NOTES_TYPE.EVALUATION_NOTE,
                    noteData.id
                  );
                });
              }}
            />
          )}
        </div>
        <div className='subText scrollAuto'>{noteData.note}</div>
      </div>
    );
  };
  renderSalesPersonNotes = (noteData) => {
    return (
      <div className='noteSection' key={noteData.id}>
        <span className='pe-3 authorText'>
          {Strings("author")}:&nbsp;
          {noteData.author}
        </span>
        <span className='subText'>
          {moment(noteData.ca).format(CONFIGURATION_DATE_TIME_FORMAT)}
        </span>
        <div className='subText scrollAuto'>{noteData.note}</div>
      </div>
    );
  };

  renderCard = (key, cardKey) => {
    return (
      <div
        className={
          cardKey === ADDRESS &&
            this.props.additionalInfo[key] &&
            this.props.additionalInfo[key][cardKey]
            ? "infoContent scrollContent"
            : "infoContent"
        }
        key={cardKey}
        title={Strings(cardKey)}
      >
        {this.props.isAnalyst && cardKey === "typeOfReference"
          ? <>
            <span>{Strings(key)}</span><span className='pencil mx-1 px-1'>
              <img
                src={editNote}
                className={"editIcon m-0"}
                alt={"edit"}
                title={Strings("EditLoanDetails")}
                onClick={() => this.showEditLoanFormModal(key)}
              />
            </span>
          </>
          : this.props.additionalInfo[key] //NOSONAR
            ? this.props.additionalInfo[key][cardKey] //NOSONAR
              ? this.props.additionalInfo[key][cardKey]
              : Strings("NA")
            : null}
      </div>
    );
  };

  renderReferences = () => {
    return (
      <>
        {this.renderHeader("References")}

        <Row className='fullWidth'>
          {this.props.additionalInfo
            ? Object.keys(this.props.additionalInfo).map((key) => {
              return (
                <div
                  className='paddingLeftZero paddingSeparation pt-3 w-auto'
                  key={key}
                >
                  <Row className='flex-column borderCard'>
                    {REFERENCES.map((cardKey) => {
                      return this.renderCard(key, cardKey);
                    })}
                  </Row>
                </div>
              );
            })
            : null}
        </Row>
      </>
    );
  };

  toggleModal = (note, noteType, noteId = null) => {
    if (this.state.isEditNote) {
      if (noteId) {
        this.setState({
          note: note,
          noteId: noteId,
          notesModal: true,
          isEditNote: true,
        });
      } else {
        const tempNoteId = this.state.noteId;
        this.setState(
          {
            notesModal: false,
            isEditNote: false,
            note: "",
            noteId: null,
          },
          () => {
            this.props.editNote(note, tempNoteId, noteType);
          }
        );
      }
    } else {
      if (note) {
        this.setState(
          {
            notesModal: false,
          },
          () => {
            this.props.addNote({
              note: note,
              type: noteType,
            });
          }
        );
      } else {
        this.setState({
          notesModal: true,
        });
      }
    }
  };

  onCloseClick = () => {
    this.setState({
      notesModal: false,
      isEditNote: false,
      note: "",
      noteId: null,
    });
  };

  renderLoanInformation = () => {
    return (
      <>
        {this.renderHeader(Strings("LoanApplicationDetails"))}
        <Row>
          <Col md={1} className='pt-2'>
            <div>
              {" "}
              <span style={{ position: "relative", display: "inline-block", lineHeight: 0 }}>
                <img src={loanImage} alt='' />
                {this.isPersonalLoan() && (
                  <img
                    src={personalLoanImage}
                    alt='personalLoanBadge'
                    title={Strings("PERSONAL_LOAN")}
                    width='32'
                    height='32'
                    style={{
                      position: "absolute",
                      bottom: "-2px",
                      right: "-2px",
                      background: "#ffffff",
                      borderRadius: "50%",
                      padding: "1px",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.25)",
                    }}
                  />
                )}
              </span>
              <div
                className='text-center infoHeader'
                title={Strings("applicationId")}
              >
                {" "}
                {this.props.applicationId}
              </div>
            </div>
          </Col>
          <Col md={11}>
            <Row className='loanInfoWrapper'>
              {this.props.loanInfo &&
                VIEW_LOAN_APP_TYPES[this.props.loanInfo.type].map(
                  (_loanKey, index) =>
                    //replaced the first parameter "loanKey" to "_loanKey" to remove sonarLint warning
                    this.renderApplicationDetails(
                      this.props.loanInfo,
                      VIEW_LOAN_APP_TYPES[this.props.loanInfo.type][
                      index
                      ]
                    )
                )}
            </Row>
          </Col>
        </Row>
        <hr className='fullWidth opacity-100' />
      </>
    );
  };

  renderEMI = () => {
    return (
      <>
        {this.renderHeader(Strings("EMICalculation"))}
        <Row>
          {" "}
          {EMI_CALCULATION.map((detail) =>
            this.renderApplicationDetails(this.props.loanInfo, detail)
          )}
        </Row>
        <hr className='fullWidth opacity-100' />
      </>
    );
  };

  renderSupplierInfo = () => {
    return <>
      {this.renderHeader(Strings("supplierInfo"))}
      {this.props.isAnalyst && <span className='pencil mx-1 px-1'>
        <img
          src={editNote}
          className={"editIcon m-0"}
          alt={"edit"}
          title={Strings("EditLoanDetails")}
          onClick={() => this.showEditLoanFormModal("supplierInfo")}
        />
      </span>}
      <Row>
        <Col
          md={3}
          className='infoViewContainer paddingSeparation ps-0'
        ><div className='infoHeader'>{Strings("sdt")}</div>
          <div className="infoContent" title={this.props.supplierInfo.sdt ? Strings(this.props.supplierInfo.sdt) : null}>{this.props.supplierInfo.sdt ? Strings(this.props.supplierInfo.sdt) : null}</div>
        </Col>
        {this.props.supplierInfo.stat && <Col
          md={3}
          className='infoViewContainer paddingSeparation ps-0'
        ><div className='infoHeader'>{Strings("stat")}</div>
          <div className="infoContent" title={this.props.supplierInfo.stat ? Strings(this.props.supplierInfo.stat) : null}>{this.props.supplierInfo.stat ? Strings(this.props.supplierInfo.stat) : null}</div>
        </Col>}
      </Row>
      <Row>
        {sd.map((key) => {
          return <Col
            md={3}
            className='infoViewContainer paddingSeparation ps-0'
            key={key}
          >
            <div className='infoHeader'>{Strings(key)}</div>
            <div className="infoContent text-truncate" title={this.props.supplierInfo?.sd[key] ? this.props.supplierInfo?.sd[key] : null}>{this.props.supplierInfo?.sd[key] ? this.props.supplierInfo?.sd[key] : null}
              {key === "rnc" && !this.props.supplierInfo.sd.isVerified && <span className="RNCInActive">{" (" + Strings("UnVerified") + ")"}</span>}
            </div>
          </Col>
        })}
      </Row>
    </>
  }

  // PERSONAL_LOAN has no supplier, so its disbursement details are shown in a dedicated block sourced
  // from loanInfo. Kept fully separate from renderSupplierInfo so the EXTERNAL_FACTORING flow is untouched.
  renderPersonalLoanDisbursementInfo = () => {
    const disbursementType = this.props.loanInfo?.selectedDisbursementType;
    const transferAccountType = this.props.loanInfo?.selectedTransferAccountType;
    return <>
      {this.renderHeader(Strings("disbursementType"))}
      {this.props.isAnalyst && <span className='pencil mx-1 px-1'>
        <img
          src={editNote}
          className={"editIcon m-0"}
          alt={"edit"}
          title={Strings("EditLoanDetails")}
          onClick={() => this.showEditLoanFormModal("supplierInfo")}
        />
      </span>}
      <Row>
        <Col
          md={3}
          className='infoViewContainer paddingSeparation ps-0'
        ><div className='infoHeader'>{Strings("sdt")}</div>
          <div className="infoContent" title={disbursementType ? Strings(disbursementType) : null}>{disbursementType ? Strings(disbursementType) : null}</div>
        </Col>
        {transferAccountType && <Col
          md={3}
          className='infoViewContainer paddingSeparation ps-0'
        ><div className='infoHeader'>{Strings("stat")}</div>
          <div className="infoContent" title={transferAccountType ? Strings(transferAccountType) : null}>{transferAccountType ? Strings(transferAccountType) : null}</div>
        </Col>}
      </Row>
    </>
  }

  renderBankInfo = () => {
    return (
      <>
        {this.props.loanInfo?.accountInfo && this.renderHeader(Strings("bankDetails"))}
        {this.props.loanInfo?.accountInfo && <Row>
          {ainfo.map((key) => {
            return <Col
              md={3}
              className='infoViewContainer paddingSeparation ps-0'
              key={key}
            >
              <div className='infoHeader'>{Strings(key)}</div>
              <div className="infoContent" title={this.props.loanInfo?.accountInfo[key] ? this.props.loanInfo?.accountInfo[key] : null}>{this.props.loanInfo?.accountInfo[key] ? this.props.loanInfo?.accountInfo[key] : null}</div>
            </Col>
          })}

        </Row>}
      </>
    )
  }

  render() {
    return (
      <>
        {this.state.showModal && this.state.sectionToEdit !== undefined && this.renderEditableModal()}

        {this.state.notesModal && (
          <NotesModal
            open={this.state.notesModal}
            modalHeader={Strings("Notes")}
            toggleModal={this.onCloseClick}
            noteType={NOTES_TYPE.EVALUATION_NOTE}
            note={this.state.note}
            isEditNote={this.state.isEditNote}
            editNote={this.toggleModal}
            addNote={this.toggleModal}
            isNotesCompulsory={true}
            maxLength={500}
            errorMessage=''
          />
        )}
        <div className='viewLoanApplication'>
          <div
            className={
              this.props.isLoanPortfolio
                ? "paper viewLoanApplicationContainer"
                : ""
            }
          >
            {this.props.isLoanPortfolio &&
              this.renderLoanInformation()}
            {this.props.supplierInfo && !this.isPersonalLoan() && this.renderSupplierInfo()}
            {this.isPersonalLoan() && this.props.loanInfo?.selectedDisbursementType && this.renderPersonalLoanDisbursementInfo()}
            {this.props.loanInfo?.accountInfo && this.renderBankInfo()}
            {BASIC_ADMIN_INFO_DETAILS_ARRAY.map((details) =>
              this.renderBasicAndadminInformation(details)
            )}
            {this.renderReferences()}
            <hr className='fullWidth opacity-100' />
            {this.props.isLoanPortfolio && this.renderEMI()}
            {OTHER_INFO_DETAILS_ARRAY.map((details) => {
              // PERSONAL_LOAN has no site-visit data, so omit that section from the details view.
              if (this.isPersonalLoan() && details.propObjectKey === "siteVisit") {
                return null;
              }
              return this.renderOtherInformation(details);
            })}
            {this.renderEvidenceDocuments()}
            {this.props.evaluationNotes?.length > 0 && (
              <Row className='fullWidth subHeaderText'>
                {Strings("EvidencesNotes")}
              </Row>
            )}
            {this.props.evaluationNotes?.length > 0 &&
              this.props.evaluationNotes.map((Note) => {
                return this.renderNotes(Note);
              })}
            {this.props.salesPersonNotes?.length > 0 && (
              <>
                <hr className='fullWidth opacity-100' />
                <Row className='subHeaderText '>
                  {Strings("SalesPersonNotes")}
                </Row>
              </>
            )}
            {this.props.salesPersonNotes?.length > 0 &&
              this.props.salesPersonNotes.map((Note) => {
                return this.renderSalesPersonNotes(Note);
              })}
          </div>
        </div>
      </>
    );
  }
}

export default ViewLoanApplication;
